const variants = {
  SUCCESS: 'SUCCESS',
  WARNING: 'WARNING',
  /*
    Maps to the `danger` palette family. The SDR lead inbox uses it for the "AI SDR" label so
    the list matches the detail panel's `Alert severity="error"` banner for the same fact, and
    so the label stays distinguishable from the SUCCESS/WARNING claim tags beside it.
  */
  DANGER: 'DANGER',
};

export default variants;
